import {
  BrandAndMarketListItem,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
  ChildProviderDetail,
  TicketingSettings,
} from '../../../integrated-client/models';

export interface IIdentityProviderSettingsFormData {
  id?: string | null;
  provider?: GuidIdAndLabel | null;
  brandAndMarket?: BrandAndMarketListItem | null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null;
  agencyName?: string | null;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  disabled?: boolean;
  countryDialingCode?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  address?: string | null;
  stateProvince?: string | null;
  officeID?: string | null;
  iataNumber?: string | null;
  city?: string | null;
  country?: string | null;
  postalCode?: string | null;
  allowEdit?: boolean;
  allowSalesTicketing?: boolean;
  cardProvider?: GuidIdAndLabel;
  childProvidersDetails?: ChildProviderDetail[] | null;
  carrier?: GuidIdCodeAndLabel;
  ticketingSettings?: Array<TicketingSettings> | null;
  useOneAirTicketing?: boolean;
  showPaxportChildSupplierSettings?: boolean;
  channelId?: string | null;
  channelName?: string | null;
  flxUserName?: string | null;
  flxPassword?: string | null;
  pcc?: string | null;
  marketCode?: string | null;
  marketName?: string | null;
  saleCity?: string | null;
  currencyCode?: string | null;
  accountCode?: string | null;
  agentName?: string | null;
  agentPassword?: string | null;
  agentRole?: string | null;
}

export interface IEditorData {
  identityProviderSettingsData?: IIdentityProviderSettingsFormData;
  validation?: any;
}
export class EditorData implements IEditorData {
  identityProviderSettingsData?: IIdentityProviderSettingsFormData;
  validation?: any;
}
